import { IIconProps } from './icon';

export const IconSmallerArrow = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconSmallerArrow${cy}`}
    >
      <path
        d="M0.666626 0.333344L3.99996 3.66668L7.33329 0.333344H0.666626Z"
        fill="#6F7171"
      />
    </svg>
  );
};
